// 3rd party
import * as React from 'react';
import { observer } from 'mobx-react';

// Hooks
import { useStores } from 'hooks';

interface MoreInformationDialogTriggerButtonProps {
  id: string;
  className?: string;
  onClick?: () => void;
}

const MoreInformationDialogTriggerButton = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function MoreInformationDialogTriggerButton(props: MoreInformationDialogTriggerButtonProps) {
    const { id, onClick, ...otherProps } = props;

    const { routeStore } = useStores();

    const dialogId = `more-information-${id.toLowerCase()}`;

    function handleClick() {
      // TODO: Add dialog trigger button click tracking

      routeStore.updateSearch({ pwaDialog: dialogId });

      onClick?.();
    }

    return <button {...otherProps} onClick={handleClick} />;
  },
);

export { MoreInformationDialogTriggerButton };
